module.exports = __webpack_public_path__ + "static/media/Neuzeit Heavy-01.de9e036d.svg";